(function(){
    "use strict";
    
    angular
        .module("app")
        .component("footer", { // footer
            templateUrl: "src/app/_shared/footer/footer.html",
            controller: controller
        });

    function controller($location) {
        const $ctrl = this;

        $ctrl.versionNumber = window.Pims.versionNumber;
        $ctrl.hideFooter = $location.$$path.indexOf("shipping-label") >= 0;

    }
    controller.$inject = ["$location"];
})()